import { render } from "./decision.vue?vue&type=template&id=2f65dc2c&scoped=true"
import script from "./decision.vue?vue&type=script&lang=js"
export * from "./decision.vue?vue&type=script&lang=js"

import "./decision.vue?vue&type=style&index=0&id=2f65dc2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f65dc2c"]])

export default __exports__